package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * One chat message bubble (Stitch `c8110400`): the caller's own messages sit at the end in the
 * primary-container teal with light text; the other party's sit at the start on a surface container.
 * The corner nearest the sender is squared (speech-tail effect). Start/end (never left/right) so RTL
 * mirrors correctly. [metaLabel] renders under the bubble (localized time, read receipt, etc.).
 */
@Composable
fun ChatBubble(
    text: String,
    mine: Boolean,
    modifier: Modifier = Modifier,
    metaLabel: String? = null,
) {
    val bubbleShape = if (mine) {
        RoundedCornerShape(
            topStart = AppTheme.shapes.chatBubbleRadius,
            topEnd = AppTheme.shapes.chatBubbleRadius,
            bottomStart = AppTheme.shapes.chatBubbleRadius,
            bottomEnd = AppTheme.shapes.chatBubbleTailRadius,
        )
    } else {
        RoundedCornerShape(
            topStart = AppTheme.shapes.chatBubbleRadius,
            topEnd = AppTheme.shapes.chatBubbleRadius,
            bottomStart = AppTheme.shapes.chatBubbleTailRadius,
            bottomEnd = AppTheme.shapes.chatBubbleRadius,
        )
    }
    Row(
        modifier = modifier.fillMaxWidth(),
        horizontalArrangement = if (mine) Arrangement.End else Arrangement.Start,
    ) {
        Column(
            horizontalAlignment = if (mine) Alignment.End else Alignment.Start,
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs),
        ) {
            Text(
                text = text,
                style = AppTheme.typography.bodyMd,
                color = if (mine) AppTheme.colors.onPrimary else AppTheme.colors.onSurface,
                modifier = Modifier
                    .widthIn(max = AppTheme.sizes.chatBubbleMaxWidth)
                    .background(
                        color = if (mine) AppTheme.colors.primaryContainer else AppTheme.colors.surfaceContainer,
                        shape = bubbleShape,
                    )
                    .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
            )
            if (metaLabel != null) {
                Text(
                    text = metaLabel,
                    style = AppTheme.typography.labelSm,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
    }
}
